import React, { Component } from 'react';
class InitialCashModal extends Component {
       render() {
        const { InsertWorkShiftT, CancelWorkShift} = this.props;
        return (
            <div>
                <div className="modal fade" id="initialCashModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="initialCashModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-body" id="grupo__initialCash">
                                <h4>Iniciar apertura de caja</h4>
                            </div>
                            
                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" data-dismiss="modal" data-toggle="modal" onClick={CancelWorkShift}>Cancelar</button>
                                <button type="button" className="btn btn-primary" data-dismiss="modal" data-toggle="modal" data-target="#vmInitialCash" onClick={InsertWorkShiftT}>Aceptar</button>
                            </div>
                        
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default InitialCashModal;